import * as CheckinCard from './CheckinCard/CheckinCard.css';
import * as CheckinCardItem from './CheckinCardItem/CheckinCardItem.css';

export default {
	CheckinCard,
	CheckinCardItem
};
